import { render, staticRenderFns } from "./teachingCenterDialog.vue?vue&type=template&id=a86c8a62&scoped=true"
import script from "./teachingCenterDialog.vue?vue&type=script&lang=js"
export * from "./teachingCenterDialog.vue?vue&type=script&lang=js"
import style0 from "./teachingCenterDialog.vue?vue&type=style&index=0&id=a86c8a62&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a86c8a62",
  null
  
)

export default component.exports